
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","viewBox":"0 0 14 8","fill":"#36C0B6","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.494 6.165c0 .376-.141.706-.376.988-.565.659-1.506.706-2.165.141L7 3.812l-3.953 3.53c-.659.564-1.6.47-2.165-.142-.564-.659-.517-1.6.142-2.165l4.94-4.33a1.512 1.512 0 012.024 0l4.988 4.33c.33.283.518.706.518 1.13z"}})])
          )
        }
      }
    